module.exports = __webpack_public_path__ + "fb-tutorial-1-en.png?3e362691aa116e95a995f3b42e648126";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-1-en.png
// module id = 04zz
// module chunks = 50